import { graphql, readInlineData } from "react-relay";

import { checkIsLongReadArticle } from "~/components/article/article-render/long-read-article/helpers";
import { checkIsMorningStudioArticle } from "~/components/article/article-render/morning-studio-article/helpers";
import { checkIsPhotoEssayArticle } from "~/components/article/article-render/photo-essay-article/helpers";
import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { checkIsStyleArticle } from "~/components/article/article-render/style-article/helper";
import { checkIsStyleSectionContent } from "~/components/section/helpers";
import type { helpersAppBarAdStatusBase$key } from "~/queries/__generated__/helpersAppBarAdStatusBase.graphql";
import type { helpersAppBarVariantArticle$key } from "~/queries/__generated__/helpersAppBarVariantArticle.graphql";

export type AppBarVariant =
  | "genericLight"
  | "genericDark"
  | "posties"
  | "postiesBrochure"
  | "style"
  | "scrollOver";

export const AppBarColorScheme: Record<AppBarVariant, "light" | "dark"> = {
  genericDark: "dark",
  genericLight: "light",
  posties: "light",
  postiesBrochure: "light",
  scrollOver: "dark",
  style: "light",
};

export const getAppBarVariant = (reference: helpersAppBarVariantArticle$key) => {
  const content = readInlineData(
    graphql`
      fragment helpersAppBarVariantArticle on Base @inline {
        ...helpersArticleSections
        ...helpersCheckIsLongReadArticle
        ...helpersCheckIsMorningStudioArticle
        ...helpersCheckIsPhotoEssayArticle
        ...helpersStyleArticle
        ...helpersStyleSectionContent
      }
    `,
    reference,
  );

  if (checkIsStyleArticle(content) || checkIsStyleSectionContent(content)) return "style";
  if (checkIsPhotoEssayArticle(content) || checkIsLongReadArticle(content)) return "scrollOver";
  if (checkIsMorningStudioArticle(content)) return "genericDark";
  if (checkIsPostiesArticle(content)) return "posties";

  return "genericLight";
};

export type AppBarAdStatus = "Enabled" | undefined;
export const getAppBarAdStatusByContent = (reference: helpersAppBarAdStatusBase$key) => {
  const content = readInlineData(
    graphql`
      fragment helpersAppBarAdStatusBase on Base @inline {
        ... on Section {
          __typename
          ...helpersStyleSectionContent
        }
      }
    `,
    reference,
  );

  return content.__typename === "Section" && checkIsStyleSectionContent(content)
    ? "Enabled"
    : undefined;
};
